import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const BoardMaster = () => {
    const authorizedAxios = generateAxiosInstance()

    const [boardName, setBoardName] = useState('')
    const [boards, setBoards] = useState([])
    const [editId, setEditId] = useState(null)

    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);

    const [nameSort, setNameSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);
    const [startIndex, setStartIndex] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["boardName", "createdAt"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setBoards(await searchArray("A", '/get-board-master', searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        const apiUrl = `/get-board-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setBoards(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(boards, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(boards.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > boards.length) {
            endIndex = boards.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(boards.slice(startIndex, endIndex));
    }, [boards, currPage, itemsPerPage]);

    const [error, setError] = useState('')

    useEffect(() => {
        if (boardName !== '') {
            setError('')
        }
    }, [boardName])

    const addBoard = () => {
        const apiUrl = `/add-board-master`;
        if (boardName != '') {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, {
                boardName,
            })
                .then(response => {
                    setBoards((prevBoards) => [...prevBoards, response.data.result]);
                    setRefresh(!refresh);
                    setSaveId(response.data.result.id);
                    setBoardName('')
                    setNameSort(null);
                    setDateSort(null);
                    setSearchValue(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            setError("This field is required.")
        }
    }

    const deleteBoard = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-board-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, boards.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }
    const updateBoard = () => {
        setLoading(true);
        const apiUrl = `/edit-board-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, {
            boardName,
        })
            .then(response => {
                setBoards((prevBoards) => [...prevBoards].map((board) => board.id == editId ? response.data.result : board));
                setEditId(null);
                setBoardName('')
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setDateSort(null);
        }
    }, [nameSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setNameSort(null);
        }
    }, [dateSort])

    const handleInputReset = () => {
        setBoardName('');
        setEditId('');
        setDateSort(null);
        setNameSort(null);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Board Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-paste"></i> Board Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12 board_name">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Board Name</label>
                                                    <input type="text" className="form-control" id="gradeName" value={boardName} onChange={(e) => setBoardName(e.target.value.toUpperCase())} />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addBoard}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateBoard} disabled={!editId}>Update</button>)
                                                    }
                                                </div>


                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}>{/*Search*/}<i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Board Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setBoards} setCurrPage={setCurrPage} sortingPath={"boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setBoards} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((board, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{board.boardName}</td>
                                                                                        {/* <td>{moment(board.createdAt).format('DD-MM-YYYY')}</td> */}
                                                                                        <td>{board.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon " type="button" onClick={() => {
                                                                                                setBoardName(board.boardName);
                                                                                                setEditId(board.id)
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>

                                                                                            <button className="btn btn-outline-danger delete_icon" disabled={editId === board.id} type="button" onClick={() => deleteBoard(board.id)}>
                                                                                                <i class="fa-light fa-trash-can"></i>
                                                                                            </button>

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Boards Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={boards?.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default BoardMaster;